import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const state: IssueTrackerState = {
};

let index = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default index;
